import { queryOptions, useQuery } from "@tanstack/react-query";
import { settingsApi } from "../api/settings";
import { requireData } from "./http";

export const settingsQueryOptions = () =>
  queryOptions({
    queryKey: ["admin-settings"] as const,
    queryFn: async ({ signal }) => requireData(await settingsApi.get(signal)),
    staleTime: 60 * 1000,
  });

export const useAdminSettings = () => useQuery(settingsQueryOptions());
